// Import the functions you need from the SDKs you need
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  // eslint-disable-next-line no-undef
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'coinowl-1ca30.firebaseapp.com',
  projectId: 'coinowl-1ca30',
  storageBucket: 'coinowl-1ca30.appspot.com',
  messagingSenderId: '648498683536',
  appId: '1:648498683536:web:b58a79f3ab88c1b6bc0215',
  measurementId: 'G-3XTEQPER2B'
};

let analytics;
if (typeof window !== 'undefined') {
  const app = initializeApp(firebaseConfig);

  analytics = getAnalytics(app);
}
// eslint-disable-next-line no-undef
setAnalyticsCollectionEnabled(analytics, process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION');

export default analytics;
